// ===========================================================================
// Module I — New Member Onboarding · Service layer
//
// Hoy sirve datos fake determinísticos (services/fakeData.js): no existe dump
// JSON para onboarding. SIMULADO hasta que el backend exponga
// outreach.TAB_ONBOARDING (fuente: SPSOURCE.dbo.TAB_ACA_NEW_MEMBER).
// ===========================================================================

import { buildNewMembers } from "./fakeData";
import { stageFor, CHECKLIST_STEPS } from "../common/constants";

/**
 * Obtiene el pipeline de onboarding de nuevos miembros de una location:
 * checklist por miembro (welcome call, records request, first appointment,
 * HRA) + etapa derivada y % de progreso.
 *
 * FUTURO ENDPOINT BACKEND: GET /api/Outreach/onboarding?locationKey={key}
 * (respaldado por outreach.TAB_ONBOARDING). Hoy: datos fake determinísticos.
 *
 * @param {string} locationKey - Key de la location (e.g. "fort_myers")
 *
 * Ejemplo de respuesta:
 * {
 *   "members": [
 *     {
 *       "cipId": 10728374651, "name": "RODRIGUEZ, MARIA", "age": 47, "gender": "F",
 *       "plan": "ACA Silver", "pcpName": "SIDDIKI, AWAIS MD",
 *       "enrollmentDate": "2026-05-02", "daysSinceEnrollment": 41,
 *       "phone": "(239) 412-3344", "email": "maria.rodriguez@example.com",
 *       "checklist": { "welcomeCall": true, "recordsRequest": true,
 *                      "firstAppointment": false, "hraCompleted": false },
 *       "stage": "RECORDS_REQUESTED", "progressPct": 50
 *     }
 *   ]
 * }
 *
 * @returns {Promise<{members: Object[]}>}
 */
export async function getOnboardingPipeline(locationKey) {
  // Latencia simulada mínima para ejercitar el estado de carga de la UI.
  await new Promise((resolve) => setTimeout(resolve, 150));

  const members = buildNewMembers(locationKey).map((m) => {
    const done = CHECKLIST_STEPS.filter((s) => m.checklist[s.key]).length;
    return {
      ...m,
      stage: stageFor(m.checklist),
      progressPct: Math.round((done / CHECKLIST_STEPS.length) * 100),
    };
  });

  // Pipeline: menos avanzados y más antiguos primero (mayor urgencia de contacto)
  members.sort(
    (a, b) => a.progressPct - b.progressPct || b.daysSinceEnrollment - a.daysSinceEnrollment
  );

  return { members };
}
